import { useMemo } from 'react';
import { useParams } from 'react-router';
import {
  GAME_CATEGORIES,
  GameCategoryName,
  GameCategoryParams
} from 'src/constants/gameCategories';

export function useGetCategoryParams() {
  const { categoryId: categoryFromUrl } = useParams<{ categoryId: GameCategoryName }>();
  const { param: categoryId } = useMemo<Partial<GameCategoryParams>>(() => {
    if (!categoryFromUrl) return { param: 'all' };
    return GAME_CATEGORIES[categoryFromUrl] || { param: 'all' };
  }, [categoryFromUrl]);

  return { categoryId };
}
